
interface UseQueryParamsOptions {
    parseBooleanValues?: boolean
}

const booleanValueMap: { [key: string]: boolean } = {
    'true': true,
    'True': true,
    'false': false,
    'False': false,
};

export function useQueryParams(search: string, options: UseQueryParamsOptions = {}): { [p: string]: null | string | boolean } {
    const searchParams = new URLSearchParams(search);
    let paramsDictionary: { [key: string]: null | string | boolean } = {};
    searchParams.forEach((value, key) => {
        if (value === '') {
            paramsDictionary[key] = null;
        } else if (options.parseBooleanValues !== false && booleanValueMap.hasOwnProperty(value)) {
            paramsDictionary[key] = booleanValueMap[value];
        } else {
            paramsDictionary[key] = value;
        }
    });
    return paramsDictionary;
}
